// src/components/TrackList.jsx
import React, { useEffect } from 'react';
import { useAudio } from '../../context/AudioProvider';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import FeatureOptionsPanel from '../panels/FeatureOptionsPanel';

import swal from 'sweetalert';

import instrumental_icon from '../../assets/frontend/images/instrumental_icon.png';

const TrackList = ({ album, currentIndex, isPlaying, isPaused, onPlayTrack, onPauseTrack, onResumeTrack }) => {

    const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

    useEffect(() => {
        if (album) {
            //loadTracklist(album, { startIndex: 0, autoPlay: false });
        }
    }, [album]);

    function openOptions(e, track) {
        e.stopPropagation();

        openCanvas({
            component: FeatureOptionsPanel,
            props: {
                track: track,
                tracklist: album,
            }
        });
    };

    var cr = 0;

    return (
        <ul className="tracklist">
            {album.tracks.map((track, index) => (
                <li key={index} className={`track ${index === currentIndex ? 'active' : ''} ${track.status !== 'active' ? 'inactive' : ''}`}>
                    <div className="horizontal-container justify-left"
                        onClick={() => {
                            if (track.status !== 'active') {
                                // show toast: not playable
                                return;
                            }
                            if (index === currentIndex && isPlaying && !isPaused) {
                                // pause handled in provider via pause(); but here we can call pause/resume through context methods
                                onPauseTrack();
                            } else if (index === currentIndex && !isPlaying && isPaused) {
                                // pause handled in provider via pause(); but here we can call pause/resume through context methods
                                onResumeTrack();
                            } else {
                                onPlayTrack(index);
                            }
                        }}>
                        <span className="">
                            {index === currentIndex && (isPlaying || isPaused) ? (
                                <span className="colored-sound-bars" aria-hidden="true">
                                    <span className="bar"></span>
                                    <span className="bar"></span>
                                    <span className="bar"></span>
                                    <span className="bar"></span>
                                    <span className="bar"></span>
                                </span>
                            ) : (
                                <span className="play-button" aria-label="Play"></span>
                            )}
                        </span>
                        <span className="pl-5">
                            <span className="font-source-sans font-size-18l-16m-14s font-weight-800 letter-spacing-0px italic">{track.title}</span>
                        </span>
                        {track.lyrics === '' && (
                             <span className="pl-5">
                                <img src={instrumental_icon} className="" alt="instrumental image" width="20" />
                            </span>
                        )}
                        <span className="align-right">
                            <div className="horizontal-container justify-right">
                                {track.type === 'demo' && (
                                    <span className="pr-10l-5s">
                                        <span className="font-poppins font-size-12 font-weight-400 letter-spacing-0px italic">Demo</span>
                                    </span>
                                )}
                                {track.type === 'prod' && (
                                    <span className="pr-10l-5s">
                                        <span className="font-poppins font-size-12 font-weight-400 letter-spacing-0px italic">In Prod</span>
                                    </span>
                                )}
                                <button className="track-button-transparent options" onClick={(e) => openOptions(e, track)}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </span>
                    </div>

                </li >
            ))}
        </ul >
    );
};

export default TrackList;
